export function waitForElement(selector: string, timeout = 3000): Promise<Element> {
  return new Promise((resolve, reject) => {
    const el = document.querySelector(selector)
    if (el) {
      resolve(el)
      return
    }
    const observer = new MutationObserver(() => {
      const found = document.querySelector(selector)
      if (found) {
        clearTimeout(timer)
        observer.disconnect()
        resolve(found)
      }
    })
    observer.observe(document.body, { childList: true, subtree: true })
    const timer = setTimeout(() => {
      observer.disconnect()
      reject(new Error(`waitForElement timeout: ${selector}`))
    }, timeout)
  })
}

function escapeRegex(str: string): string {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

export function findButtonByText(text: string, scope?: Element): HTMLButtonElement | null {
  const container = scope ?? document
  const buttons = Array.from(container.querySelectorAll('button'))
  for (const btn of buttons) {
    const content = btn.textContent?.trim()
    if (content && new RegExp(`^${escapeRegex(text)}$`, 'i').test(content)) {
      return btn
    }
  }
  return null
}

export function findButtonByAriaLabel(text: string, scope?: Element): HTMLButtonElement | null {
  const container = scope ?? document
  const buttons = Array.from(container.querySelectorAll('button'))
  for (const btn of buttons) {
    const label = btn.getAttribute('aria-label')?.trim()
    if (label && new RegExp(`^${escapeRegex(text)}$`, 'i').test(label)) {
      return btn
    }
  }
  return null
}

export function findCheckboxByLabel(text: string, scope?: Element): HTMLElement | null {
  const container = scope ?? document
  const checkboxes = Array.from(
    container.querySelectorAll<HTMLElement>('[role="checkbox"], input[type="checkbox"]')
  )
  for (const cb of checkboxes) {
    const label = cb.getAttribute('aria-label')?.trim() ?? cb.textContent?.trim() ?? ''
    if (new RegExp(escapeRegex(text), 'i').test(label)) {
      return cb
    }
  }
  const labels = Array.from(container.querySelectorAll<HTMLElement>('label'))
  for (const label of labels) {
    if (new RegExp(escapeRegex(text), 'i').test(label.textContent?.trim() ?? '')) {
      const input = label.querySelector<HTMLElement>('input[type="checkbox"], [role="checkbox"]')
      if (input) return input
      return label
    }
  }
  return null
}
